'use strict';

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

// http://www.toolserver.org/tiles/bw-mapnik/${z}/${x}/${y}.png
// http://www.toolserver.org/tiles/bw-mapnik/{z}/{x}/{y}.png
// http://tile.openstreetmap.us/vectiles-water-areas/{z}/{x}/{y}.mvt
// http://www.naturalearthdata.com/downloads/110m-physical-vectors/
// http://gis.stackexchange.com/questions/1617/rendering-custom-openstreetmaps-style-land-white-water-black-do-i-need-a-ded
// http://mc.bbbike.org/mc/?lon=-1.33386&lat=47.15491&zoom=11&num=2&mt0=mapnik
// http://tile.openstreetmap.fr/


ngModule.run(function (leaflet) {
    // setting leaflet default paths
    leaflet.Icon.Default.imagePath = "/images/leaflet";
});

ngModule.run(function(applicationSettings, leafletDefaultConfig) {

    applicationSettings.get().then(function(settings) {
        if(settings.leafletTilesUrl) {
            leafletDefaultConfig.tiles.url = settings.leafletTilesUrl;
        }
    });

});

ngModule.factory("leafletDefaultConfig", function () {

    var worldMaxBounds = {
        northEast: {
            lat: 90,
            lng: 180
        },
        southWest: {
            lat: -90,
            lng: -180
        }
    };

    return {
        options: {
            minZoom: 4,
            maxZoom: 12,
            attributionControl: false,
            tileLayerOptions: {
                attribution: '&copy; <a href="https://www.taelys.com">Taelys</a> | &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }
        },
        maxbounds: worldMaxBounds,
        tiles: {
            url: 'https://tiles.taelys.com/{z}/{x}/{y}.png'
        }
    };
});








// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/leaflet/leaflet-config.js